import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Michael T.',
    location: 'Miami, FL to Newport, RI',
    text: "LynJones Logistics made shipping my 32' Travel Trailer completely stress-free. The driver was professional, kept me updated, and the RV arrived in perfect condition. Highly recommend their RV transport services."
  }, {
    name: 'Sarah Jenkins',
    location: 'San Diego, CA to Seattle, WA',
    text: 'I was nervous about shipping my Class A motorhome across the coast, but they handled everything flawlessly. No upfront payment gave me peace of mind, and the final price matched the quote exactly.'
  }, {
    name: 'David R.',
    location: 'Austin, TX to Charleston, SC',
    text: "Best RV movers I've ever used. Fast quote, clear communication, and they handled the oversized permits for my fifth wheel without a hitch. Will use them again."
  }];
  return <section className="py-20 bg-slate-50" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-282">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-283">
            Trusted by RV Owners Nationwide
          </h2>
          <p className="text-lg text-slate-600" data-id="element-284">
            Don't just take our word for it. See what our customers say about
            our reliable RV shipping services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-285">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative" data-id="element-286">
              <div className="flex gap-1 mb-4" data-id="element-287">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-288" />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-289">
                "{review.text}"
              </p>
              <div data-id="element-290">
                <p className="font-bold text-brand-navy" data-id="element-291">{review.name}</p>
                <p className="text-sm text-slate-500" data-id="element-292">{review.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}